// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"xVCW9","modalControls":"A5n5l","deleteBtnWrapper":"iHUYs"};